/**
 * OpenStreetMap Block - Inizializzazione automatica
 * Cerca elementi JSON di configurazione e inizializza le mappe Leaflet corrispondenti.
 */
(function() {
    'use strict';

    /**
     * Inizializza una singola mappa OpenStreetMap
     * @param {Object} config Configurazione della mappa
     */
    function initMap(config) {
        let mapElement = document.getElementById(config.elementId);
        if (!mapElement) {
            console.error('[OpenStreetMap] Element not found:', config.elementId);
            return;
        }

        let map = L.map(config.elementId, {
            center: [config.center.lat, config.center.lng],
            zoom: config.zoom || 17,
            scrollWheelZoom: config.scrollWheelZoom !== false
        });

        // Tile layer selection
        if (config.style === 'openstreetmap') {
            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                detectRetina: true,
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }).addTo(map);
        } else if (config.style && config.style.indexOf('maplibreGL') !== -1) {
            L.maplibreGL({
                detectRetina: true,
                maxZoom: 19,
                style: 'https://tiles.openfreemap.org/styles/bright'
            }).addTo(map);
        }

        map.dragging.enable();

        // Creazione markers
        let markers = [];
        if (config.markers && config.markers.length > 0) {
            config.markers.forEach(function(markerConfig) {
                let marker = L.marker([markerConfig.lat, markerConfig.lng], {
                    draggable: false,
                    icon: L.ExtraMarkers.icon({
                        shadowUrl: config.shadowUrl,
                        shadowRetinaUrl: config.shadowRetinaUrl,
                        icon: markerConfig.icon || 'fa-number',
                        iconColor: markerConfig.iconColor || 'white',
                        number: markerConfig.name || '',
                        markerColor: markerConfig.markerColor,
                        shape: markerConfig.shape || 'circle',
                        svg: true
                    })
                }).addTo(map);

                // Popup
                if (markerConfig.popup) {
                    marker.bindPopup(markerConfig.popup);
                }

                // Click handler per aprire popup e centrare la mappa
                marker.on('click', function() {
                    marker.openPopup();
                    let popup = marker.getPopup();
                    if (popup && popup._container) {
                        map.panBy([0, -popup._container.offsetHeight * 0.8], { animate: true });
                    }
                });

                markers.push(marker);
            });
        }

        // Fit bounds o set view
        if (markers.length === 0) {
            mapElement.classList.add('hidden');
        } else if (markers.length === 1) {
            map.setView([config.markers[0].lat, config.markers[0].lng], config.zoom || 17);
        } else if (markers.length > 1) {
            let bounds = [];
            config.markers.forEach(function(m) {
                bounds.push([m.lat, m.lng]);
            });
            map.fitBounds(new L.LatLngBounds(bounds));
        }
    }

    /**
     * Cerca tutti gli elementi di configurazione OpenStreetMap e inizializza le mappe
     */
    function autoInit() {
        let configElements = document.querySelectorAll('script[type="application/json"].openstreetmap-config');

        configElements.forEach(function(element) {
            try {
                let config = JSON.parse(element.textContent);
                initMap(config);
                // Rimuovo l'elemento di configurazione dopo l'uso
                element.parentNode.removeChild(element);
            } catch (error) {
                console.error('[OpenStreetMap] Failed to parse configuration:', error);
            }
        });
    }

    // Auto-inizializzazione al caricamento del DOM
    if (typeof domLoaded === 'function') {
        domLoaded(autoInit);
    } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', autoInit);
    } else {
        autoInit();
    }
})();
